import {
  CheckState,
  CommonUtils,
  Selectable,
  StandardEntity,
} from '@infodata-group/inf-commons';
import { computed, Signal, signal, WritableSignal } from '@angular/core';
import { CartographyInfosResourcePosition } from '../cartography-resource-infos/cartography-resource-infos-position/cartography-infos-resource-position';
import { AoSharedTools } from '../../engine/tools/ao-shared-tools';
import dayjs from 'dayjs';

export abstract class CartographyResource
  extends StandardEntity
  implements Selectable
{
  public labelResource = '';

  private _check: boolean;
  get checkState(): CheckState {
    return this.check && this.isValidLatLng()
      ? CheckState.check
      : CheckState.uncheck;
  }
  get check(): boolean {
    return this._check === true;
  }
  set check(value: boolean) {
    this._check = value;
  }
  public override display: 'full' | 'id' | 'label' = 'label';
  public latitude: number;
  public longitude: number;
  public lat: WritableSignal<number> = signal(null);
  public lng: WritableSignal<number> = signal(null);
  public isValidLatLng: Signal<boolean> = computed(() =>
    AoSharedTools.isValidLatLng(this.lat(), this.lng()),
  );
  public latLng: Signal<google.maps.LatLng> = computed(() => {
    return new google.maps.LatLng(this.lat(), this.lng());
  });
  public date: Date;
  public get dateText(): string {
    return dayjs(this.date).format('DD/MM/YYYY HH:mm:ss');
  }
  public hour: string;
  public address: string;
  public groupId: string;
  public options: unknown;
  public enable: boolean;
  public iconColor: string;
  public normalizedText = this.getLabel();
  public updatedPositionAt: Date;

  public eventListeners: {
    type: string;
    listener: (this: HTMLDivElement, ev: MouseEvent) => any;
  }[] = [];

  public get iconTable(): string {
    if (!this.iconColor) {
      return `${this.icon.toLowerCase()}`;
    }
    return `${this.icon.toLowerCase()} ${this.iconColor.replace('#', '').toLowerCase()}`;
  }

  public get labelTab(): string {
    return this.labelResource || this.getLabel();
  }

  public isInfoWindowLocked = false;

  public updatePosition(position: CartographyInfosResourcePosition): void {
    if (!this.checkPosition(position)) {
      return;
    }
    this.lat.set(position.latitude);
    this.lng.set(position.longitude);
    this.latitude = position.latitude;
    this.longitude = position.longitude;
    this.date = position.date;
    this.hour = position.hour;
    this.updatedPositionAt = new Date();
  }

  public match(search: string): boolean {
    return CommonUtils.normalize(this.getLabel(), true).includes(
      CommonUtils.normalize(search, true),
    );
  }

  public matchFilter(field: string, value: string): boolean {
    return this[field] == value;
  }

  protected checkPosition(position: CartographyInfosResourcePosition): boolean {
    return position.idResource === this.getId();
  }
}
